import { render, staticRenderFns } from "./SkeletonNotification.vue?vue&type=template&id=2db74105&"
import script from "./SkeletonNotification.vue?vue&type=script&lang=js&"
export * from "./SkeletonNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports